import ENVIRONMENT_CONFIG from "@velzon/config/environment.config.js";
import axios from "axios";
import qs from "qs";
import { refreshToken } from "api/authentication/auth.js";
import { handleLogOut } from "../auth/index.js";

// default
axios.defaults.baseURL = ENVIRONMENT_CONFIG.REACT_APP_API_BASE_URL;
axios.defaults.withCredentials = true;
// content type
// axios.defaults.headers.post["Content-Type"] = "application/json";

// content type
// function init () {
//   const token = JSON.parse(localStorage.getItem("authUser")) ? JSON.parse(localStorage.getItem("authUser")).token : null;
//   if (token)
//     axios.defaults.headers.common["Authorization"] = "Bearer " + token;
// }
// init()

// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    if (response.config?.responseType === 'blob') {
      return response; // return full response with headers
    }
    return response.data ? response.data : response;
  },
  async (error) => {
    const originalRequest = error.config;

    const isAuthEndpoint = originalRequest?.url?.includes('/auth/user-login') ||
                          originalRequest?.url?.includes('/auth/refresh-token') ||
                          originalRequest?.url?.includes('/auth/reset-password') ||
                          originalRequest?.url?.includes('/auth/forgot-password') ||
                          originalRequest?.url?.includes('/auth/validate-token')

    if (
      error.response?.status === 401 &&
      !originalRequest._retry && !isAuthEndpoint
    ) {
      originalRequest._retry = true;

      try {
        await refreshToken();
        return axios(originalRequest);
      } catch (err) {
        // prevent retry loop
        // eslint-disable-next-line no-console
        console.error("Refresh token failed:", err);
        handleLogOut();
        window.location.href = "/login";
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);
/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token) => {
  // console.log("Bearer",token)
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

class APIClient {
  /**
   * Fetches data from given url
   */

  //  get = (url, params) => {
  //   return axios.get(url, params);
  // };
  get = (url, params, config = {}) => {
    // let response;

    // let paramKeys = [];

    // if (params) {
    //   Object.keys(params).map(key => {
    //     paramKeys.push(key + '=' + params[key]);
    //     return paramKeys;
    //   });

    //   const queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : "";
    //   response = axios.get(`${url}?${queryString}`, params);
    // } else {
    //   response = axios.get(`${url}`, params);
    // }

    // return response;

    return params ?
      axios.get(`${url}`, {
        ...config,
        params, paramsSerializer: params => {
          return qs.stringify(params, { indices: false })
        }
      }) :
      axios.get(`${url}`, params);
  };

  /**
   * post given data to url
   */
  create = (url, data) => {
    return axios.post(url, data);
  };
  /**
   * Updates data
   */
  update = (url, data) => {
    return axios.patch(url, data);
  };

  post = (url, data) => {
    return axios.post(url, data);
  };

  put = (url, data) => {
    return axios.put(url, data);
  };
  /**
   * Delete
   */
  delete = (url, config) => {
    return axios.delete(url, { ...config });
  };
}
const getLoggedInUser = () => {
  const user = localStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export { APIClient, setAuthorization, getLoggedInUser };